// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"151":"4410080c","196":"543f34d8","318":"7ce6f3b1","553":"1fcd73af"}[chunkId] + ".css";
};